import _extends from 'babel-runtime/helpers/extends';

import _ from 'lodash';
// import { fetchCreationTag } from '@/api/demand/creation'

/**
 * 接口返回data列表字段于vue字段不一致，字段转换
 */
export var dataConversion = function dataConversion(data, key) {
  var cloneData = _.cloneDeep(data);
  var subKey = key || 'sub_tags';

  var changeKey = function changeKey(data) {
    data.forEach(function (item, i) {
      data[i]['label'] = data[i]['name'];
      delete data[i]['name'];
      // 递归
      if (data[i][subKey] && data[i][subKey].length > 0) {
        data[i]['children'] = data[i][subKey];
        delete data[i][subKey];
        changeKey(data[i].children);
      }
    });
  };

  changeKey(cloneData);

  return cloneData;
};

export default {
  name: 'cascaderMulti',
  componentName: 'cascaderMulti',
  props: {
    config: {
      type: Object,
      required: true
    },
    formValue: {
      type: Object,
      required: true
    }
  },

  data: function data() {
    return {};
  },


  computed: {
    innerConfig: function innerConfig() {
      var params = _extends({
        clearable: true,
        placeholder: '请选择标签',
        size: 'medium',
        valueKey: 'id'
      }, this.config.params);
      params.data = dataConversion(this.config.params.options || []);
      return _extends({}, this.config, {
        params: params
      });
    }
  },

  mounted: function mounted() {},


  methods: {}
};